import { useMediaQuery } from "react-responsive";

export default function BreakPoints() {
	return {
		xSmall: useMediaQuery({ maxWidth: 575.98 }),
		small: useMediaQuery({ minWidth: 576, maxWidth: 767.98 }),
		medium: useMediaQuery({ minWidth: 768, maxWidth: 991.98 }),
		large: useMediaQuery({ minWidth: 992, maxWidth: 1199.98 }),
		xLarge: useMediaQuery({ minWidth: 1200, maxWidth: 1399.98 }),
		xXLarge: useMediaQuery({ minWidth: 1400 }),
	};
}
